import * as React from "react";

import { cn } from "@/shared/utils/utils";

const Skeleton = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref): React.ReactElement => {
  return (
    <div
      ref={ref}
      data-slot="skeleton"
      className={cn(
        "relative overflow-hidden rounded-10 bg-muted",
        "before:absolute before:inset-0 before:content-['']",
        "before:-translate-x-full",
        "before:animate-[shimmer_1.5s_infinite]",
        "before:bg-gradient-to-r",
        "before:from-transparent before:via-[color:var(--muted-foreground)]/10 before:to-transparent",
        className,
      )}
      {...props}
    />
  );
});
Skeleton.displayName = "Skeleton";

export { Skeleton };
